<template>
  <footer class="global-footer">
    <div class="footer-content">
      <div class="footer-info">
        <p class="copyright">© 甘肃智能网联车辆测试示范服务系统 | ICP备案12031756号</p>
        <p class="registrations">
          <span>甘ICP证150143号</span> |
          <span>甘公网安备11010502036099号</span>
        </p>
      </div>
      <div class="footer-qr">
        <img :src="require('@/assets/images/about_wx.png')" alt="公众号" class="qr-code" />
        <span class="qr-text">公众号</span>
      </div>
    </div>
  </footer>
</template>

<script setup name="footer">
</script>

<style scoped lang="less">
.global-footer {
  background-color: #1890ff;
  padding: 50px 0;
  color: white;
  font-size: 16px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 700px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-info {
  text-align: left;
}

.copyright {
  margin: 0 0 5px 0;
  font-weight: 500;
}

.registrations {
  margin: 0;
  opacity: 0.9;
}

.link {
  color: white;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}

.footer-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-code {
  width: 110px;
  height: 110px;
  border: 2px solid white;
  border-radius: 4px;
  margin-bottom: 5px;
}

.qr-text {
  font-size: 16px;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
  }
  
  .footer-info {
    margin-bottom: 20px;
  }
}
</style>